import Vimeo from '@vimeo/player'
import { sleep } from '../../js/modules/helper-functions'

export const settings = {
  selector: '.js-vimeo-video',
}

/**
 * Function initializes all elements in page.
 */
export default function initAll() {
  let elements = document.querySelectorAll( settings.selector )
  Array.from( elements ).forEach(( element ) => {
    loadIframe( element )
    init( element )
  })
}

/**
 * Function initializes the Vimeo player form
 * the iframe.
 *
 * @param {DOMNode} iframe
 */
 function loadIframe( element ) {
  const iframe = element.querySelector( 'iframe' )
  var loadTime = Date.now() - window.performance.timing.navigationStart
  if ( !iframe.dataset.timeout ) iframe.src = iframe.dataset.lazySrc
  if ( iframe.dataset.lazySrc && loadTime < iframe.dataset.timeout ) {
    iframe.src = iframe.dataset.lazySrc
  }

}


/**
 * Function initializes single element.
 * @param {DOMNode} element
 */
export async function init( element ) {
  const iframe = element.querySelector( 'iframe' )
  const { autoplay } = element.dataset
  if ( iframe.classList.contains( 'lazyloaded' )) {
    if ( iframe.src.includes( 'vimeo' )) {
      initVimeoPlayer( iframe, autoplay == 'true' )
    }
  } else {
    await sleep( 200 )
    init( element )
  }
}

/**
 * Function initializes the Vimeo player form
 * the iframe.
 *
 * @param {DOMNode} iframe
 */
function initVimeoPlayer( iframe, autoplay = true ) {
  const player = new Vimeo( iframe )
  player.setVolume( 0 )
  if ( autoplay ) {
    player.play()
  }
}
